module.exports = __webpack_public_path__ + "static/media/systemdblogoblk.c04ab1ae.png";